import { useEffect, useState } from 'react';

export const useWindowRef = (onMessage, onClose) => {
  const [w, setWindow] = useState();

  const listener = function(event) {
    if (
      event.data &&
      typeof event.data === 'object' &&
      event.data.source &&
      event.data.source === 'backend'
    ) {
      const { success, data } = event.data;
      success &&
        onMessage &&
        typeof onMessage === 'function' &&
        onMessage(event.data);
      if (data.windowClose) {
        w.close();
      }
    }
  };

  useEffect(() => {
    if (w) {
      window.addEventListener('message', listener);

      const id = setInterval(() => {
        if (w && w.closed) {
          setWindow(null);
          clearInterval(id);
          window.removeEventListener('message', listener);
          typeof onClose === 'function' && onClose();
        }
      }, 300);

      return () => {
        setWindow(null);
        clearInterval(id);
        window.removeEventListener('message', listener);
      };
    }
  }, [w]);

  return [setWindow];
};
